import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingComponent from '../LoadingComponent';

type RequireAuthProps = {
  children: ReactNode;
  isAuthenticated: boolean;
  loading: boolean;
};

const RequireAuth = ({
  children,
  isAuthenticated,
  loading,
}: RequireAuthProps) => {
  const location = useLocation();

  if (loading) {
    return <LoadingComponent message="Loading..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default RequireAuth;
